"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debouncedSubjectSpecifications = exports.updateInventorySpecification = exports.crateInventorySpecification = exports.deleteInventorySpecification = exports.getInventorySpecification = exports.getInventorySpecifications = void 0;
const tslib_1 = require("tslib");
const Api = tslib_1.__importStar(require("../../privateRequest"));
const parsers_1 = require("./parsers");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const getInventorySpecifications = async (params) => {
    const response = await Api.get('references/inventory/specifications', params);
    return (0, parsers_1.parseInventorySpecifications)(response);
};
exports.getInventorySpecifications = getInventorySpecifications;
const getInventorySpecification = async (id) => {
    const response = await Api.get('references/inventory/specifications/' + id);
    return (0, parsers_1.parseInventorySpecification)(response);
};
exports.getInventorySpecification = getInventorySpecification;
const deleteInventorySpecification = async (id) => {
    return await Api.deleteItem('references/inventory/specifications/' + id);
};
exports.deleteInventorySpecification = deleteInventorySpecification;
const crateInventorySpecification = async (params) => {
    const response = await Api.post('references/inventory/specifications', params);
    return (0, parsers_1.parseInventorySpecification)(response);
};
exports.crateInventorySpecification = crateInventorySpecification;
const updateInventorySpecification = async (id, params) => {
    const response = await Api.patch('references/inventory/specifications/' + id, params);
    return (0, parsers_1.parseInventorySpecification)(response);
};
exports.updateInventorySpecification = updateInventorySpecification;
exports.debouncedSubjectSpecifications = lodash_1.default.debounce((keyword, callback) => {
    searchSubjectSpecifications({ filters: { keyword } }).then(res => callback(res));
}, 300, { maxWait: 1000 });
const searchSubjectSpecifications = async (params) => {
    const { data, errors } = await (0, exports.getInventorySpecifications)(params);
    return (0, parsers_1.parseSpecificationsForSelect)(data, errors);
};
